<template>
  <v-layout text-xs-center wrap fluid>
    <v-flex mb-4 xs12 text-xs-left>
      <div class="orderBanner" b>주문번호 Order #T7320-{{ order.id }}</div>
      <v-btn
        v-if="order_detail_link"
        :to="`/events/${event_id}/orders/${order.id}`"
        style="float: right; "
      >
        <v-icon dark>edit</v-icon>
      </v-btn>
      <b>Order Status:</b> {{ order_status.en }}
      <br />
      <b>주문상태:</b>{{ order_status.ko }}

      <!-- (1315321.56/1000).toLocaleString('en-US', {minimumFractionDigits: 1, maximumFractionDigits: 1}) -->
      <br /><b>금액 Amount:</b> {{ order.currency }}
      {{ (1 * order.amount).toLocaleString() }} <br /><b
        >결제수단 Payment Method:</b
      >
      {{ sales_channel_name }} {{ order.sales_channel_identifier }}

      <v-alert :value="needs_payment" type="info">
        <div v-if="order.pay_by">
          <b>입금마감 Pay By:</b> <br />{{ order.pay_by_text }}
        </div>
      </v-alert>
      <div v-if="order.refunded_at">
        <b>환불/Refunded At:</b> {{ order.refunded_at }}
      </div>

      <div
        v-for="pplog in order.paypal_logs"
        :key="`${order.id}-pplog-${pplog.id}`"
        class="paypal_log"
      >
        Paypal TXN: {{ pplog.txn }} - {{ pplog.currency }} {{ pplog.amount }}
        <span v-if="pplog.is_success">Succesful</span>
      </div>

      <v-alert :value="needs_payment && !has_deposit" color="info">
        <b>입금 정보 Payment Info:</b>
        <div v-html="sales_channel_payment_html"></div>
        <div v-if="is_sales_channel_paypal">
          <div v-if="paypal_direct">
            <v-btn
              color="warning"
              v-show="!paypal_visible && !paypal_loading"
              @click="render_paypal"
              >Pay using Paypal</v-btn
            >
            <div v-show="!paypal_visible && paypal_loading">Loading Paypal</div>
            <div :id="paypal_div_id"></div>
          </div>
          <div v-else>
            <v-btn :to="`/events/${event_id}/orders/${order.id}`">
              Go to paypal payment page
            </v-btn>
          </div>
        </div>
      </v-alert>

      <div
        v-for="order_item in order.order_items"
        :key="`${order.id}-${order_item.id}`"
        class="order_item"
      >
        <b>상품 Product:</b> {{ order_item.product.name }}
        <br />
        수량 Qty:{{ order_item.qty }} @ {{ order_item.currency }}
        {{ (1 * order_item.price).toLocaleString() }} <br />&nbsp; &nbsp;
        <b
          >= 총액 / Total {{ order_item.currency }}
          {{ (1 * order_item.price * order_item.qty).toLocaleString() }}
        </b>
        <v-alert v-if="false" :value="needs_payment" type="info">
          <div v-if="order_item.pay_by">
            <b>입금마감 Pay By:</b> <br />{{ order_item.pay_by_text }}
          </div>
        </v-alert>

        <div v-if="has_sequence(order_item)">
          신청 순위 Sequence #{{ order_item.sequence }}
          <!-- {{ order_item.product.capacity }} -->
          <div v-if="order.canceled_at == null">
            <v-chip
              color="green"
              text-color="white"
              v-if="
                (order_item.sequence < order_item.product.capacity &&
                  order.submitted_at) ||
                  order.submitted_at
              "
            >
              <v-icon>star</v-icon>
              <b>결제 가능 Reservation Confirmed</b>
            </v-chip>
            <span v-else>
              (Wait List)
              <v-alert :value="true" type="warning">
                대기번호 / Wait List - #{{
                  order_item.sequence - order_item.product.capacity
                }}
                <br />
                <b>{{ order_status.en }}</b>
                <br /><b>{{ order_status.ko }}</b>
              </v-alert>
            </span>
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex';

export default {
  props: ['order', 'paypal_direct', 'order_detail_link'],
  data: () => ({paypal_loading: false, paypal_visible: false}),
  beforeMount: async function() {},
  mounted() {
    if (this.is_sales_channel_paypal) {
      this.render_paypal();
    }
  },

  computed: {
    ...mapState(['event_products', 'event_sales_channels', 'event_orders']),
    event_id() {
      var eid = this.$route.params.event_id;
      return eid;
    },
    sales_channel() {
      return this.event_sales_channels?.find(x => {
        return x.id == this.order.sales_channel_id;
      });
    },
    sales_channel_name() {
      let sc = this.sales_channel;
      return sc?.name;
    },
    sales_channel_payment_html() {
      let sc = this.sales_channel;
      return sc?.payment_html;
    },
    is_sales_channel_paypal() {
      return 'Paypal' == this.sales_channel_name;
    },
    has_deposit() {
      if (this.order.canceled_at) {
        return false;
      } else if (this.order.deposited_at) {
        return true;
      } else {
        return false;
      }
    },
    needs_payment() {
      if (this.order.canceled_at) {
        return false;
      } else if (!this.order.submitted_at) {
        return false;
      } else {
        if (!this.order.paid_at) {
          return true;
        } else {
          return false;
        }
      }
    },
    order_status() {
      if (this.order.canceled_at) {
        return {
          en: 'Canceled - Order Not Valid',
          ko: '취소 - Order Not Valid',
        };
      } else if (!this.order.submitted_at) {
        return {
          en: 'On Hold - You are on the waiting list, do NOT pay.',
          ko: '정원이 초과되어 대기자입니다. 입금하지 마세요.',
        };
      } else {
        // ABX only deposits required, balance at door
        if (!this.order.paid_at) {
          if (this.order.deposited_at) {
            return {
              en: 'Non-refundable Deposit Received',
              ko: 'Non-refundable Deposit Received',
            };
          } else {
            return {
              en: 'Awaiting Payment',
              ko: '입금 대기 중 - 입금해주시기 바랍니다.',
            };
          }
        } else {
          return {
            en: 'Order Paid & Complete',
            ko: '주문 및 입금확인이 완료되었습니다.',
          };
        }
      }
    },
    paypal_div_id() {
      return `paypal-button-container-${this.order_id}`;
    },
  },
  methods: {
    has_sequence(order_item) {
      if (order_item.sequence === undefined) {
        return false;
      } else {
        return true;
      }
    },
    product_lookup(product_id) {
      return this.event_products?.find(x => {
        return x.id == product_id;
      });
    },
    pp_sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    paypal_check: async function(ms) {
      await sleep(ms);
      if (paypal === undefined) {
        return false;
      } else {
        return true;
      }
    },
    ensure_paypal: async function() {
      var ppurl = `https://www.paypal.com/sdk/js?client-id=${this.order.paypal_client_id}`;
      if (this.order.paypal_sandbox) {
        ppurl = `https://sandbox.paypal.com/sdk/js?client-id=${this.order.paypal_client_id}`;
      }
      console.log('load js:', ppurl);
      if (typeof paypal === 'undefined') {
        setTimeout(() => {
          let ppscript = document.createElement('script');
          ppscript.setAttribute('src', ppurl);
          document.head.appendChild(ppscript);
        }, 0);
        // wait for paypal to become true
        var sleepms = 100;
        while (true) {
          if (typeof paypal === 'undefined') {
            console.log('no paypal yet, wait ', sleepms);
          } else {
            return true;
          }
          await this.pp_sleep(sleepms);
          sleepms = sleepms * 2;
        }
      }
    },
    render_paypal: async function() {
      if (this.paypal_loading) return;
      if (this.paypal_visible) return;

      this.paypal_loading = true;
      await this.ensure_paypal();
      this.paypal_loading = false;

      var pp_reference_id = `order:${this.order.id};`;
      var pp_amount_value = this.order.amount;
      var pp_event_id = this.$route.params.event_id;
      var pp_order_id = this.order.id;
      var pp_dispatch = this.$store.dispatch;
      var pp_info = {
        purchase_units: [
          {
            reference_id: pp_reference_id,
            amount: {
              currency_code: 'USD',
              value: '9.00', // ABX2024 deposit only
              //value: pp_amount_value,
            },
          },
        ],
      };
      console.log(pp_info);

      paypal
        .Buttons({
          createOrder: function(data, actions) {
            // Set up the transaction
            return actions.order.create(pp_info);
          },
          onApprove: function(data, actions) {
            return actions.order.capture().then(function(details) {
              console.log(
                'Transaction completed by ' + details.payer.name.given_name,
              );
              console.log(data, actions, details);
              // data: {orderID: "54L41810K4159864F", payerID: "XLXQTR3UEYT3N"}
              // actions: {order: {…}, restart: ƒ, redirect: ƒ} order: {capture: ƒ, authorize: ƒ, patch: ƒ, get: ƒ} redirect: ƒ (n,e) restart: ƒ a()
              /* details: create_time: "2019-02-17T16:27:53Z"
		id: "54L41810K4159864F"
		intent: "CAPTURE"
		payer:
		    address: {country_code: "US"}
		    email_address: "mirage-buyer@rateaprof.com"
		    name: {given_name: "test", surname: "buyer"}
		    payer_id: "XLXQTR3UEYT3N"
		    phone: {phone_number: {…}}
		purchase_units: Array(1)
		    0: {reference_id: "default", soft_descriptor: "PAYPAL *JEFFREYCHAN", amount: {…}, payee: {…}, shipping: {…}, …}
		status: "COMPLETED"
		update_time: "2019-02-17T16:27:53Z"<Paste>
	      */
              pp_dispatch('verifyPaypalPayment', {
                event_id: pp_event_id,
                order_id: pp_order_id,
                paypal_order_id: data.orderID,
              });
            });
          },
        })
        .render(`#${this.paypal_div_id}`);
      this.paypal_visible = true;
    },
  },
};
</script>

<style scoped>
.order_item {
  border: 1px solid black;
}

.orderBanner {
  background: blue;
  color: white;
  display: block;
  font-size: 1.2em;
  font-weight: bold;
  text-align: center;
  padding: 0.25em;
  margin-bottom: 0.25em;
}
</style>
